import moment from "moment";
import languages from "../assets/languages.json";
import Environment from "../environment";

const supportedLanguages = ["en", "vi"];
const defaultLanguageCode = "en";
const momentLanguageCode = {
    "en": null,
    "vi": null
}

const T = (str, params = {}) => {
    let text = str;
    if (!!Environment.languageSupport) {
        const currentLanguageCode = getCurrentLanguageCode();
        setMomentLanguage(currentLanguageCode);
        text = languages && languages[str] && languages[str][currentLanguageCode] ? languages[str][currentLanguageCode] : str;
    }

    for (const paramsKey in params) {
        text = text.split(`{${paramsKey}}`).join(params[paramsKey]);
    }
    return text;
}

export function getCurrentLanguageCode() {
    if (Environment.languageSupport) {
        // @ts-ignore
        const browserLanguageCode = (window.navigator.language || window.navigator?.userLanguage).split("-")[0];
        const localStorageLanguageCode = window.localStorage.getItem("language");
        // Check language flow from localStorage, browser, and default in supported languages
        if (localStorageLanguageCode && supportedLanguages.includes(localStorageLanguageCode)) {
            return localStorageLanguageCode;
        } else if (supportedLanguages.includes(browserLanguageCode)) {
            return browserLanguageCode;
        }
        return defaultLanguageCode;
    } else {
        return defaultLanguageCode;
    }
}

export function setCurrentLanguageCode(languageCode) {
    if (Environment.languageSupport) {
        const currentLanguageCode = getCurrentLanguageCode();
        if (currentLanguageCode === languageCode) return;
        // Set the current language code of the user
        window.localStorage.setItem("language", languageCode);
        window.location.reload();
    }
}

const setMomentLanguage = (languageCode) => {
    if (!!Environment.languageSupport) {
        moment.updateLocale(languageCode, momentLanguageCode[languageCode]);
        // set moment monday is start of week
        moment.locale(languageCode);
    }
}

export default T;